import { Navigate, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { AuthCard } from "@/components/AuthCard";
import { FullScreenLoader } from "@/components/FullScreenLoader";
import { ChangePasswordForm } from "@/pages/admin/settings/ChangePasswordForm";
import { useAuth, homeFor } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nProvider";

// Shown when an admin-assigned temporary password must be replaced before continuing.
export default function ForceChangePassword() {
  const { t } = useI18n();
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.must_change_password) return <Navigate to={homeFor(user)} replace />;
  const signOut = (
    <button type="button" onClick={logout} data-testid="force-change-logout"
      className="mt-6 flex items-center gap-2 self-center rounded px-2 py-2 text-sm font-semibold text-[#000B45] underline-offset-4 hover:underline">
      <LogOut className="h-4 w-4" /> {t("common.logout")}
    </button>
  );
  return (
    <AuthCard testId="force-change" title={t("auth.forceChangeTitle")} subtitle={t("auth.forceChangeSubtitle")} footer={signOut}>
      <ChangePasswordForm bare temporary onDone={(u) => navigate(homeFor(u), { replace: true })} />
    </AuthCard>
  );
}
